export default __webpack_public_path__ + "static/tm-420500bc4c84152aefd62c3a4ad0f89e.svg";